import * as yup from 'yup';

export const profileUpdateSchema = yup.object({
  firstName: yup
    .string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters long')
    .max(50, 'First name must not exceed 50 characters')
    .matches(/^[a-zA-Z\s]+$/, 'First name can only contain letters and spaces'),
  lastName: yup
    .string()
    .required('Last name is required')
    .min(2, 'Last name must be at least 2 characters long')
    .max(50, 'Last name must not exceed 50 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Last name can only contain letters and spaces'),
  email: yup.string().email('Invalid email').required('Email is required'),
  whatsappNumber: yup
    .string()
    .required('WhatsApp number is required')
    .matches(
      /^\+?[1-9]\d{1,14}$/,
      'Please enter a valid WhatsApp number (with or without country code)'
    ),
});

export type ProfileUpdateFormData = yup.InferType<typeof profileUpdateSchema>;
